import * as z from 'zod'

import { useQuery } from '@tanstack/react-query'
import { useSelectedTeamAndRepo } from '../use-selected-team-and-repo'
import { useIsExternalVisitor } from '../use-user-role'
import { useSelectedBranchOrCommitQuery } from '~/lib/commits/use-selected-branch-or-commit'
import { isBranch } from '@basehub/data/replicache/index'

const outputSchema = z.object({
  bshbPreview: z.string(),
  previewRef: z.string().nullish(),
  repoId: z.string(),
  queryParam: z.string(),
})

export const usePreviewToken = () => {
  const { data } = useSelectedTeamAndRepo()
  const { data: branchOrCommit } = useSelectedBranchOrCommitQuery()
  const isExternalVisitor = useIsExternalVisitor()

  const ref =
    (branchOrCommit &&
      (isBranch(branchOrCommit) ? branchOrCommit.name : branchOrCommit.id)) ||
    null

  return useQuery(
    ['repo-preview-token', data?.repo?.id as string, ref],
    async () => {
      if (!data?.team || !data?.repo) return null

      const res = await fetch(
        `/api/nextjs/preview-auth?teamId=${data.team.id}&repoId=${data.repo.id}&ref=${ref}`
      )
      if (res.status === 200) {
        const json = await res.json()
        const parsedBody = outputSchema.pick({ bshbPreview: true }).parse(json)
        return outputSchema.parse({
          ...parsedBody,
          previewRef: ref,
          repoId: data.repo.id,
          queryParam: `?${ref ? `bshb-preview-ref=${ref}&` : ''}bshb-preview=${
            parsedBody.bshbPreview
          }`,
        })
      } else {
        throw new Error(res.statusText)
      }
    },
    {
      enabled: !!data?.repo && !!data?.team && !isExternalVisitor,
      staleTime: Infinity,
    }
  )
}
